<section class="bg-light page-section" id="team">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase">Our Team</h2>
          <h3 class="section-subheading text-muted">Meet our amazing team</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4" *ngFor="let member of ts.team">
          <div class="team-member">
            <img class="mx-auto rounded-circle" [src]="'assets/img/team/'+ member.image" alt="">
            <h4>{{member.name}}</h4>
            <p class="text-muted">{{member.role}}</p>
            <ul class="list-inline social-buttons">
              <li class="list-inline-item">
                <button mat-mini-fab [title]="member.phone"><mat-icon>phone</mat-icon></button>
              </li>
              <li class="list-inline-item">
                <button mat-mini-fab [title]="member.email"><mat-icon>mail</mat-icon></button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 mx-auto text-center">
          <p class="large text-muted">We are ready to serve you</p>
        </div>
      </div>
    </div>
  </section>